import { ServiceSearchButtons } from 'feature/serviceCenters/components'
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { ReactNode } from 'react'
import { LoaderInCentalPosition } from 'widget'

import style from './ServiceCentersDesktop.module.scss'

type TServiceCentersDesktop = {
  setPageType: (value: 'services' | 'address') => void
  isServicesListLoading: boolean
  children: ReactNode
}
// страница сервисных центров на десктопном расширении
export function ServiceCentersDesktop({
  setPageType,
  isServicesListLoading,
  children,
}: TServiceCentersDesktop) {
  return (
    <div className={style.tabPanel}>
      <YandexMap
        className={style.map}
        isMapClickable={false}
        marks={[MarkType.geolocationMark, MarkType.serviceMarks]}
        controls={[
          ControlsType.ZoomControl,
          ControlsType.GeolocationControlUnit,
        ]}
      />
      <div className={style.tabPanelRight}>
        <ServiceSearchButtons setPageType={setPageType} />
        <div className={style.line} />
        {isServicesListLoading && (
          <LoaderInCentalPosition className={style.loader} />
        )}
        {!isServicesListLoading && <>{children}</>}
      </div>
    </div>
  )
}
